// The dismiss / remove ✕, and the counterpart to HeartIcon: the two appear as
// a pair on every Editor's Picks row and on the daily hero, and the instruction
// block above them names both. Having one of them be a shared component and the
// other four copies of the same <path> is how they drift apart.
//
// Same prop shape as HeartIcon (`color`, `className`) so the two are used
// identically at a call site. The implementation differs on purpose: HeartIcon
// masks external SVG files, which is the only way to recolor artwork it doesn't
// own, whereas this path is inline and takes a `stroke` directly. `color`
// defaults to `currentColor`, so a caller can tint it with a text class instead
// of passing a value.
//
// `inline-block` is load-bearing, not decoration: Tailwind's preflight sets
// `svg { display: block }`, so without it this breaks onto its own line when
// used mid-sentence. HeartIcon gets the same behaviour for free by being a
// <span>. It costs nothing inside the icon buttons, where a flex container
// blockifies its children anyway.

// How much bigger the glyph is drawn than its source path, scaled about the
// centre of the viewBox. Done here rather than by editing the path data or the
// call sites' width/height classes, so every usage keeps its existing box and
// the mark grows inside it. The stroke scales along with the path, which is
// what makes this read as a uniformly bigger ✕ rather than a longer, thinner
// one. Two 10% passes so far; this is the one number to change.
const GLYPH_SCALE = 1.21;

function DismissIcon({ color = 'currentColor', className = '' }) {
  return (
    <svg
      aria-hidden="true"
      className={`inline-block ${className}`}
      fill="none"
      stroke={color}
      strokeWidth="3"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6 18L18 6M6 6l12 12"
        transform={`translate(12 12) scale(${GLYPH_SCALE}) translate(-12 -12)`}
      />
    </svg>
  );
}

export default DismissIcon;
